// Copyright (c) 2017 Deere & Company

import SearchByDropDown from '../state/search-by-dropdown';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const findMatchingOption = (key, options) => options.find(option => option.key === key);

const updateSearchBy = (state, action) =>
    SearchByDropDown.update(state, {
        selectedOption: {
            $set: findMatchingOption(action.key, state.searchBy)
        }
    });

export default (state = getDefaultState().searchByDropDown, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_BY]: updateSearchBy
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/search/reducers/search-by-dropdown.js